import { Injectable, signal, WritableSignal } from '@angular/core';

export interface DsHeaderUserInfo {
  username: string;
  department: string;
  profileImg: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  userInfo: WritableSignal<Partial<DsHeaderUserInfo>> = signal({
    username: '',
    department: localStorage.getItem('companyId') || '',
    profileImg: 'https://www.gravatar.com/avatar/?d=identicon',
  });
}
